import script from "./InfoCenterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoCenterPage.vue?vue&type=script&setup=true&lang=ts"

import "./InfoCenterPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__